import styled from 'styled-components'

const ListItemContainer = styled.div`
  .list-item {
    display: flex;
    position: relative;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 25px;
    max-height: 550px;
    overflow: hidden auto;
    padding-bottom: 10px;
  }
  .infinite-scroll-component::-webkit-scrollbar-track {
    border: 1px solid #000;
    padding: 3px 0;
    background-color: #000;
    margin-bottom: 20px;
  }

  .infinite-scroll-component::-webkit-scrollbar {
    width: 5px;
  }

  .infinite-scroll-component::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #2f323e;
    border: 1px solid #000;
  }
  .button-group {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 40px !important;
    >div {
      margin: 0 16.5px;
      width: auto;
    }
  }

  .not-found {
    font-size: 24px;
    color: #fff;
    text-transform: uppercase;
    width: 100%;
  }
  .view-more-container {
    width: 100%;
    display: flex;
    justify-content: center;
    height: 40px;

    .btn-view-more {
      background: linear-gradient(
        178.19deg,
        rgb(240 241 240 / 82%) 1.64%,
        rgb(235 245 241 / 48%) 47.93%,
        rgb(251 251 251 / 63%) 97.84%
      );
      border-radius: 4px;
      height: 100%;
      width: 250px;
      font-size: 16px;
      &-text {
        margin: 16px;
        color: white;
      }
    }
    .btn-view-more:hover {
      background: linear-gradient(
        178.19deg,
        rgb(120 229 147 / 82%) 1.64%,
        rgb(52 255 184 / 48%) 47.93%,
        rgb(78 240 118 / 63%) 97.84%
      );
    }
    .btn-view-more:after {
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid #f9fafb;
      content: '';
      position: relative;
      right: -5px;
      top: 11px;
    }
  }
`

export default ListItemContainer
